import { styled } from '@mui/styles';
import { StatusWrapper } from '../../Applications/components/ApplicationStatus/styles';

export const InvitedStatusWrapper = styled(StatusWrapper)(({ theme }) => ({
  background: theme.palette.primary.light,
  color: theme.palette.primary.dark
}));

export const NotInvitedStatusWrapper = styled(StatusWrapper)(({ theme }) => ({
  background: theme.palette.grey[200],
  color: theme.palette.grey[600]
}));
